import { render, staticRenderFns } from "./btnGroup.vue?vue&type=template&id=3ccbcd3d"
import script from "./btnGroup.vue?vue&type=script&lang=js"
export * from "./btnGroup.vue?vue&type=script&lang=js"
import style0 from "./btnGroup.vue?vue&type=style&index=0&id=3ccbcd3d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports